export const ColorValues = {
  Pink: "pink",
  Purple: "purple",
  LightBlue: "lightblue",
  Blue: "blue",
  Green: "green",
  Yellow: "yellow",
  Orange: "orange",
  Red: "red",
  LightGreen: "lightgreen",
  Brown: "brown",
  Grey: "grey",
  Reset: "reset",
} as const;

export type ColorName = (typeof ColorValues)[keyof typeof ColorValues];

export const Colors: Record<ColorName, string> = {
  pink: "rgb(255, 141, 226)",
  purple: "rgb(139, 75, 251)",
  lightblue: "rgb(80, 207, 255)",
  blue: "rgb(14, 38, 255)",
  green: "rgb(4, 141, 31)",
  yellow: "rgb(255, 197, 48)",
  orange: "rgb(255, 125, 65)",
  red: "rgb(255, 48, 48)",
  lightgreen: "rgb(81, 218, 108)",
  brown: "rgb(139, 104, 78)",
  grey: "rgb(115, 115, 115)",
  reset: "",
};

export const HightlightColors: Record<ColorName, string> = {
  pink: "rgba(255, 141, 226, 0.4)",
  purple: "rgba(139, 75, 251, 0.4)",
  lightblue: "rgba(80, 207, 255, 0.4)",
  blue: "rgba(14, 38, 255, 0.4)",
  green: "rgba(4, 141, 31, 0.4)",
  yellow: "rgba(255, 197, 48, 0.4)",
  orange: "rgba(255, 125, 65, 0.4)",
  red: "rgba(255, 48, 48, 0.4)",
  lightgreen: "rgba(81, 218, 108, 0.4)",
  brown: "rgba(139, 104, 78, 0.4)",
  grey: "rgba(115, 115, 115, 0.4)",
  reset: "",
};

export const BlockBgColors: Record<ColorName, string> = {
  pink: "rgba(255, 141, 226, 0.1)",
  purple: "rgba(139, 75, 251, 0.1)",
  lightblue: "rgba(80, 207, 255, 0.1)",
  blue: "rgba(14, 38, 255, 0.1)",
  green: "rgba(4, 141, 31, 0.1)",
  yellow: "rgba(255, 197, 48, 0.1)",
  orange: "rgba(255, 125, 65, 0.1)",
  red: "rgba(255, 48, 48, 0.1)",
  lightgreen: "rgba(81, 218, 108, 0.1)",
  brown: "rgba(139, 104, 78, 0.1)",
  grey: "rgba(115, 115, 115, 0.1)",
  reset: "",
};
